<template>
  <div>
    <navigation-menu-member v-if="isMember()"></navigation-menu-member>
    <navigation-menu-manager
      v-else-if="userMode == 'MANAGE'"
    ></navigation-menu-manager>
    <navigation-menu-mentor
      v-else-if="userMode == 'MENTOR'"
    ></navigation-menu-mentor>
  </div>
</template>

<script>
import NavigationMenuManager from "@/containers/navigations/NavigationMenuManager"
import NavigationMenuMember from "@/containers/navigations/NavigationMenuMember"
import NavigationMenuMentor from "@/containers/navigations/NavigationMenuMentor"
// import ModeSwitcher from "@/containers/navigations/ModeSwitcher"
// import SelectedMember from "@/containers/navigations/SelectedMember"
import userMixin from "@/mixins/userMixin"

import { mapGetters } from "vuex"

export default {
  mixins: [userMixin],
  components: {
    NavigationMenuManager,
    NavigationMenuMember,
    NavigationMenuMentor
    // ModeSwitcher,
    // SelectedMember
  },
  computed: {
    ...mapGetters("globals", { userMode: "getUserMode" })
  }
}
</script>
